// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box-res .data-cont{display:flex;flex-direction:column}.box-res .data-cont .title{order:1}.box-res .data-cont .inner{order:2}.box-res .data-cont .gift{order:3}.box-res .data-cont .next{order:4}", ""]);
// Exports
module.exports = exports;
